import { createAppQueryClient } from "@how/app-kit";

export { isAuthorizationError } from "@how/app-kit";
export const queryClient = createAppQueryClient();
